import SelectInstructorInputContainer from './SelectInstructorInputContainer';

export default SelectInstructorInputContainer;
